/* eslint-disable no-redeclare */
/* eslint-disable no-loop-func */
/* eslint-disable eqeqeq */
import { PureComponent, useRef, useEffect } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import {
  ClassicEditor,
  Bold,
  Essentials,
  Italic,
  Paragraph,
  List,
} from 'ckeditor5';
import {
  Segment,
  Icon,
  Table,
  Button,
  Grid,
  Popup,
  GridColumn,
  Modal,
} from 'semantic-ui-react';
import moment from 'moment';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { CSVLink } from 'react-csv';
import { withTranslation } from 'react-i18next';

import { BrowseFile, CustomTable, CustomTooltip } from '../../../../components';

import '../activity.scss';
import {
  isEmpty,
  map,
  cloneDeep,
  sum,
  flattenDeep,
  get,
  filter,
  compact,
  size,
  orderBy,
} from '../../../../utils/lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
// import { EvaluationSurvey } from './activityEvaluation';
import {
  postProjectEvaluations,
  uploadActivityCsv,
  getEvalReasons,
  getEvalAssesmentTypes,
  updateSelfAssessed,
  evalPlanManage,
  exportEvaluationResponses,
  exportEvaluationResponsesByFile,
  getEvaluationComment,
  getEvaluationPlans,
  saveEvaluationNarrative,
  toggleCommentShortlist,
  putEvaluationReportInclusion,
} from '../../../../store/actions';
import { averageValue, getPageDisable } from '../../../../utils';
import { INSTANCE_WITH_CULTURE_COUNTS } from '../../../../utils/instanceConstant';
import { UserTextService } from '../../../../services';
import CopyToClipboard from 'react-copy-to-clipboard';
import NotificationManager from 'react-notifications/lib/NotificationManager';
import { ActivityOutcomeRatings } from '../../../../components/charts/ActivityOutcomeRatings';
import { EvaluationReportInclusionToggle } from '../../../../components/charts/EvaluationReportInclusionToggle';

class UploadCsvComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      value: {},
    };
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  uploadFileHandler = (file) => {
    this.setState({ loading: true }, async () => {
      try {
        const {
          uploadActivityCsv,
          toggle,
          evaluation,
          evalPlan,
          chart,
          resetData,
        } = this.props;
        let formData = new FormData();
        formData.set('upfile', file);
        if (evaluation) {
          formData.append('projectId', evaluation.projectId);
          formData.append('objectiveId', evaluation.objectiveId);
          formData.append('date', moment().format('YYYY-MM-DD'));
          if (
            get(evaluation, 'method.response', null) === 'Participant' &&
            get(evaluation, 'method.method', null) === 'Intercept' &&
            get(evalPlan, 'collectionMethod', null) === 'CULTURECOUNTS'
          ) {
            formData.append('isCultureCount', true);
          }
        }
        await uploadActivityCsv(evaluation, formData);
        await this.setState({ loading: false }, () => {
          resetData();
          chart();
        });
        toggle();
      } catch (error) {
        this.setState({ loading: false });
      }
    });
  };

  render() {
    const { modal, toggle, t } = this.props;
    return (
      <Modal
        size="small"
        open={modal}
        onOpen={() => toggle()}
        closeIcon={
          <Icon onClick={() => toggle()} name="close" className="closeicon" />
        }
      >
        <Modal.Header>{t('activity.evaluation.upload_csv_file')}</Modal.Header>
        <Modal.Content>
          <BrowseFile
            label={t('activity.evaluation.upload_evaluation_template')}
            name="strategic"
            accept=".csv"
            buttonText={t('actions.browse').toUpperCase()}
            uploadFile={this.uploadFileHandler}
            loading={this.state.loading}
            csv
          />
        </Modal.Content>
      </Modal>
    );
  }
}

const UploadCsv = withTranslation()(UploadCsvComponent);

const NARRATIVE_TOOLBAR = {
  plugins: [Essentials, Bold, Italic, List, Paragraph],
  toolbar: ['bold', 'italic', 'bulletedList', 'numberedList'],
  placeholder:
    'Add your own bullet point observations on what the evaluation data and respondent comments tell us.',
};

// Functional wrapper so hooks work inside the class-component tree.
// `initialData` is used as the key so the editor remounts if the value
// is updated externally (e.g. from the report builder).
function NarrativeCKEditor({ initialData, onSave, disabled }) {
  const editorRef = useRef(null);
  const initialDataRef = useRef(null);
  if (initialDataRef.current === null) {
    initialDataRef.current = initialData || '';
  }
  const editorDataRef = useRef(initialDataRef.current);
  const onSaveRef = useRef(onSave);
  onSaveRef.current = onSave;
  // Track whether the user has typed anything so we don't clobber their edits
  // when the API data arrives after mount.
  const hasUserEditedRef = useRef(false);

  // When reportNarrative arrives from the API after the initial render (async
  // load via getEvaluationPlans), push the new content into the editor — but
  // only if the user hasn't started typing yet.
  useEffect(() => {
    if (
      !hasUserEditedRef.current &&
      initialData &&
      editorRef.current &&
      initialData !== editorDataRef.current
    ) {
      editorRef.current.setData(initialData);
      initialDataRef.current = editorRef.current.getData();
      editorDataRef.current = initialDataRef.current;
    }
  }, [initialData]);

  // Save is normally driven by CKEditor's internal blur event, but switching
  // tabs (e.g. Evaluation -> Report) unmounts this component directly without
  // ever firing that blur, silently discarding the pending edit. Flush on
  // unmount as a safety net, mirroring the blur condition exactly.
  useEffect(() => {
    return () => {
      if (editorDataRef.current !== initialDataRef.current) {
        onSaveRef.current(editorDataRef.current);
      }
    };
  }, []);

  return (
    <div className="report-ck-field">
      <CKEditor
        editor={ClassicEditor}
        config={NARRATIVE_TOOLBAR}
        data={initialDataRef.current}
        disabled={disabled}
        onChange={(event, editor) => {
          hasUserEditedRef.current = true;
          editorDataRef.current = editor.getData();
        }}
        onReady={(editor) => {
          editorRef.current = editor;
          // Sync both refs to CKEditor's normalised version of the initial
          // content so the change-detection comparison is always like-for-like.
          const normalised = editor.getData();
          initialDataRef.current = normalised;
          editorDataRef.current = normalised;
          editor.editing.view.document.on('blur', () => {
            if (editorDataRef.current !== initialDataRef.current) {
              onSaveRef.current(editorDataRef.current);
            }
          });
        }}
      />
    </div>
  );
}

class EvaluationQuestion extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showQ: false,
      evaluation: null,
      loading: false,
      participantResponse: [],
      chartMode: 'trend',
    };
  }

  handleChartModeChange = (mode) => {
    this.setState((prev) =>
      prev.chartMode === mode ? prev : { chartMode: mode }
    );
  };

  async componentDidMount() {
    const {
      getEvaluationComment,
      evaluation,
      currentActivity,
      getEvaluationPlans,
    } = this.props;
    await getEvaluationPlans(currentActivity.id);
    await getEvaluationComment(currentActivity.id, evaluation.evaluationPlanId);
    this.setParticipantResponse();
  }

  setParticipantResponse() {
    let evaluation = cloneDeep(this.props.evaluation);
    this.setState({
      participantResponse: isEmpty(evaluation.participantResponse)
        ? []
        : evaluation.participantResponse,
    });
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  chartReRender() {
    this.chart && this.chart.renderChart();
  }

  onChange(value, arryNumber, i) {
    let { participantResponse } = this.state;
    let evaluation = cloneDeep(this.props.evaluation);
    const count = parseInt(value) ? parseInt(value) : 0;
    participantResponse[arryNumber][i] = count;
    this.setState(
      {
        participantResponse,
      },
      async () => {
        evaluation.participantResponse = participantResponse;
        try {
          await this.props.postProjectEvaluations(
            evaluation,
            `evaluationQuestion${evaluation.objectiveId}`
          );
          this.chartReRender();
        } catch (error) {
          //
        }
      }
    );
  }

  controlQuestion() {
    this.setState((prevState) => ({
      showQ: !prevState.showQ,
    }));
  }

  getRemainingParticipants(
    participantResponse,
    { actualParticipantsEvaluated },
    index
  ) {
    const { t } = this.props;
    let count = 0;
    if (participantResponse.length) {
      if (index) {
        count = sum(participantResponse[index]);
      } else {
        count = sum(participantResponse[0]);
      }
    }

    if (actualParticipantsEvaluated - count >= 0) {
      return actualParticipantsEvaluated - count;
    }
    return (
      <span className="error-count">
        <Icon color="red" name="warning sign" />
        {t('activity.evaluation.participants_exceeded', {
          count: count - actualParticipantsEvaluated,
        })}
      </span>
    );
  }

  async componentDidUpdate(prevProps) {
    const {
      isFileChanged,
      getEvaluationComment,
      evaluation,
      currentActivity,
      getEvaluationPlans,
    } = this.props;

    if (
      prevProps.evaluation.actualParticipantsEvaluated !==
      this.props.evaluation.actualParticipantsEvaluated
    ) {
    }

    // check file is uploaded if it's update charts, tables, and other eval-plan data
    if (isFileChanged) {
      await getEvaluationComment(
        currentActivity.id,
        evaluation.evaluationPlanId
      );
      await getEvaluationPlans(currentActivity.id);
      this.setParticipantResponse();
      this.chartReRender();
    }
  }

  // get the responses uploaded/ collected by file (CSV)
  async participantResponseExportByFile(evaluation) {
    const { exportEvaluationResponsesByFile } = this.props;
    await exportEvaluationResponsesByFile(`evaluationQuestion`, evaluation);
    const { evaluationResponsesCsvLink } = this.props;
    if (!isEmpty(evaluationResponsesCsvLink)) {
      window.open(evaluationResponsesCsvLink.download_link, '_blank');
    }
  }

  render() {
    const { showQ, participantResponse, chartMode } = this.state;
    const {
      evaluation,
      evalPlan,
      index,
      user,
      helpTips,
      putEvaluationReportInclusion,
      currentActivity,
      t,
    } = this.props;

    const reportAssistEnabled = get(
      user,
      'organisation.reportAssistEnabled',
      false
    );
    const showChartProse =
      reportAssistEnabled &&
      get(user, 'organisation.reportAssistOptions.showChartProse', true) !==
        false;

    const handleProse = (text) => {
      const existing = this.props.evaluation.reportNarrative;
      // Auto-seeded narratives are staff-editable once written, so this only
      // ever overwrites text that hasn't been through the current generator:
      // empty, still in the pre-bullet plain-text format, or still carrying
      // the old "rating points" wording from before the % change.
      const isPlainText = existing && !existing.includes('<');
      const isOutdatedWording = existing && existing.includes('rating points');
      if (text && (!existing || isPlainText || isOutdatedWording)) {
        this.props.saveEvaluationNarrative(
          this.props.evaluation.projectId,
          this.props.evaluation.id,
          text
        );
        // saveEvaluationNarrative only PUTs — it doesn't update Redux — so
        // broadcast the save too: ActivitySteps' central BroadcastChannel
        // listener picks this up and merges it into Redux directly, which is
        // what makes this.props.evaluation.reportNarrative reflect the save
        // (rather than local override state, which used to break whenever
        // this component was unmounted — e.g. switching Evaluation steps).
        const ch = new BroadcastChannel('takso_activity');
        ch.postMessage({
          type: 'evaluationNarrative',
          activityId: this.props.evaluation.projectId,
          evaluationId: this.props.evaluation.id,
          reportNarrative: text,
        });
        ch.close();
      }
    };

    const [one = [], two = []] = participantResponse;
    const participantResponseCount = sum(flattenDeep(participantResponse)) || 0;
    const onlineResponseCount = Number(
      get(evaluation, 'responseCounts.online', 0)
    );
    const csvResponseCount = Number(get(evaluation, 'responseCounts.csv', 0));
    const shouldShowSourceResponseCounts =
      onlineResponseCount > 0 && csvResponseCount > 0;
    const isDisabled =
      get(evalPlan, 'isDisabled', false) ||
      getPageDisable(currentActivity, user, 'project.edit.evaluationPlan');
    const activeCultureCount =
      get(evalPlan, 'method.response', null) === 'Participant' &&
      get(evalPlan, 'method.method', null) === 'Intercept' &&
      get(evalPlan, 'collectionMethod', null) === 'CULTURECOUNTS';
    const csvRespondentType = String(
      get(evalPlan, 'method.response', 'participant')
    ).toLowerCase();
    const isCsvImportEnabled =
      evalPlan.collectionMethod === 'LINK' ||
      evalPlan.collectionMethod === 'CSV' ||
      evalPlan.collectionMethod === 'CULTURECOUNTS';
    const customQuestionHeaders = map(
      get(evalPlan, 'customQuestions', []),
      (question) => {
        const label = get(question, 'label') || get(question, 'type', '');
        return label
          ? {
              label,
              key: `customQuestion:${question.id}:${label}`,
            }
          : null;
      }
    ).filter(Boolean);

    const questioner = {
      __html: evaluation
        ? UserTextService.removeEditableText(`
            ${index === 0 ? evaluation.methodHeading || '' : ''}
            ${evaluation.heading || ''}<br/>
            ${evaluation.question1 || ''}<br/>
            ${evaluation.question2 || ''}<br/>`)
        : null,
    };

    /**
     *  This is used for evaluation charts withouts self assessment type plans
     */
    // TAK 1894
    // const participantGroups = get(evalPlan, 'participantGroups', []);
    // const totalParticipantsforSampleRecommendation = !isEmpty(participantGroups)
    //   ? sum(
    //       map(participantGroups, (group) => {
    //         const actualSize =
    //           get(group, 'targetGroup.actualSize', null) ??
    //           get(group, 'actualSize', null);
    //         const defaultSize =
    //           get(group, 'targetGroup.size', null) ?? get(group, 'size', 0);
    //         const resolvedSize = Number(actualSize ?? defaultSize);
    //         return Number.isNaN(resolvedSize) ? 0 : resolvedSize;
    //       })
    //     )
    //   : Number(get(evalPlan, 'totalParticipants', 0)) || 0;

    // const recommendedSampleSize = Math.ceil(
    //   totalParticipantsforSampleRecommendation * 0.95
    // );

    return (
      <Segment
        className="eval-que-seg"
        loading={
          // this.props.actPut[`evaluationQuestion${evaluation.objectiveId}`]
          //   ? this.props.actPut[`evaluationQuestion${evaluation.objectiveId}`]
          //   :
          this.state.loading || this.props.activity.evalPlanLoading
        }
      >
        <div>
          <div className="eval-que-div">
            <>
              <div className="participant-res">
                {evalPlan.collectionMethod === 'MANUAL' ? (
                  <p>
                    {t('activity.evaluation.manual_collection_instruction')}
                  </p>
                ) : null}

                {/* evaluation isNewCsvFeature: upload all objectives data in one CSV file */}
                {isCsvImportEnabled && !evalPlan.isNewCsvFeature ? (
                  <Segment
                    disabled={
                      this.props.currentActivity.statusId == 3
                        ? get(evalPlan, 'isSeriesActive', false)
                          ? true
                          : false
                        : false
                    }
                  >
                    <label className="participant-lbl">
                      {t('activity.evaluation.import_csv_data')}
                    </label>
                    <p>
                      {activeCultureCount
                        ? t('activity.evaluation.culture_counts_instruction')
                        : t('activity.evaluation.csv_template_instructions', {
                            csvRespondentType,
                          })}
                    </p>
                    <div>
                      <CSVLink
                        className={
                          isDisabled
                            ? // || (!get(evalPlan, 'isSeriesActive', false) &&
                              //   get(evalPlan, 'seriesParentId', null))
                              'disabled-csv'
                            : ''
                        }
                        // Not translated because the headers are literally used in backend
                        headers={
                          Boolean(evaluation.cumulative)
                            ? [
                                {
                                  label: 'response date',
                                  key: 'responseDate',
                                },
                                {
                                  label: 'after response (1-10)',
                                  key: 'afterResponse',
                                },
                                {
                                  label: 'before response (1-10)',
                                  key: 'beforeResponse',
                                },
                                {
                                  label: 'reason (free text)',
                                  key: 'reason',
                                },
                                ...(evalPlan.isTakker
                                  ? [{ label: 'takker', key: 'takker' }]
                                  : []),
                                ...customQuestionHeaders,
                              ]
                            : [
                                {
                                  label: 'response date',
                                  key: 'responseDate',
                                },
                                {
                                  label: 'participant response (1-10)',
                                  key: 'participantResponse',
                                },
                                {
                                  label: 'reason (free text)',
                                  key: 'reason',
                                },
                                ...(evalPlan.isTakker
                                  ? [{ label: 'takker', key: 'takker' }]
                                  : []),
                                ...customQuestionHeaders,
                              ]
                        }
                        data={evalPlan.isTakker ? [{ takker: 'true' }] : []}
                        filename={
                          evaluation && evaluation.outcome
                            ? `${evaluation.outcome.title}.csv`
                            : 'template.csv'
                        }
                      >
                        {activeCultureCount ? null : (
                          <Button
                            icon
                            labelPosition="left"
                            className="upload-btn"
                            disabled={isDisabled}
                          >
                            <Icon name="cloud download" />
                            {evalPlan.isTakker
                              ? t(
                                  'activity.evaluation.download_takker_csv_template'
                                )
                              : t('activity.evaluation.download_csv_template')}
                          </Button>
                        )}
                      </CSVLink>
                      <Button
                        icon
                        labelPosition="left"
                        className="upload-btn"
                        onClick={() => this.toggle()}
                        disabled={isDisabled}
                      >
                        <Icon name="upload" />
                        {activeCultureCount && INSTANCE_WITH_CULTURE_COUNTS
                          ? t(
                              'activity.evaluation.import_culture_counts_survey'
                            )
                          : t('activity.evaluation.upload_csv')}
                      </Button>
                    </div>
                  </Segment>
                ) : null}
              </div>

              <UploadCsv
                setFile={this.setFile}
                modal={this.state.modal}
                toggle={() => this.toggle()}
                chart={() => this.chartReRender()}
                resetData={() => this.setParticipantResponse()}
                {...this.props}
              />

              <Segment>
                <div className="url-card">
                  <div className="obj-div inside-question">
                    <div className="eval-participants-div">
                      <CustomTooltip
                        state={get(user, 'options.tips')}
                        contentObject={{
                          data: helpTips,
                          key: '59',
                        }}
                        position="bottom left"
                      >
                        <div>
                          <label className="participants-top">
                            {t(
                              'activity.evaluation.number_of_participants_completed',
                              { value: evaluation.actualParticipantsEvaluated }
                            )}
                          </label>
                          {shouldShowSourceResponseCounts ? (
                            <div className="participants-source-counts">
                              <div>
                                {t(
                                  'activity.evaluation.number_of_online_responses',
                                  { value: onlineResponseCount }
                                )}
                              </div>
                              <div>
                                {t(
                                  'activity.evaluation.number_of_csv_responses',
                                  { value: csvResponseCount }
                                )}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </CustomTooltip>
                      {/* <CustomTooltip
                      state={get(user, 'options.tips')}
                      contentObject={{ data: helpTips, key: '59' }}
                      position="bottom left"
                    >
                      <Input
                        className="participants-input participants-disabled"
                        name="actualParticipantsEvaluated"
                        value={evaluation.actualParticipantsEvaluated}
                        disabled={true}
                        type="number"
                      />
                    </CustomTooltip> */}
                      {/* TAK 1894!!! QUICK FIX */}
                      {/* <label className="participants-bottom-custom">
                        {t('activity.evaluation.recommended_sample_size_is', { recommendedSampleSize })}
                      </label> */}
                    </div>
                  </div>
                </div>
              </Segment>

              {Boolean(evaluation.cumulative) ? (
                <>
                  {one && one.length ? (
                    <Segment>
                      <div className="response-table-div">
                        <h4 className="afterBerforeHeading">
                          {t('activity.evaluation.after')}
                        </h4>
                        <Table
                          className="response-table"
                          celled
                          padded
                          unstackable
                        >
                          <Table.Header>
                            <Table.Row>
                              <Table.HeaderCell>
                                {t('common.not_at_all').toUpperCase()}
                              </Table.HeaderCell>
                              <Table.HeaderCell>2</Table.HeaderCell>
                              <Table.HeaderCell>3</Table.HeaderCell>
                              <Table.HeaderCell>4</Table.HeaderCell>
                              <Table.HeaderCell>5</Table.HeaderCell>
                              <Table.HeaderCell>6</Table.HeaderCell>
                              <Table.HeaderCell>7</Table.HeaderCell>
                              <Table.HeaderCell>8</Table.HeaderCell>
                              <Table.HeaderCell>9</Table.HeaderCell>
                              <Table.HeaderCell>
                                {t('common.most_imaginable').toUpperCase()}
                              </Table.HeaderCell>
                            </Table.Row>
                          </Table.Header>
                          <Table.Body>
                            <Table.Row>
                              {map(one, (data, i) => (
                                <Table.Cell key={i}>
                                  <AvForm ref={(c) => (this.data = c)}>
                                    <AvField
                                      type="number"
                                      name={`before-prepost-${i}`}
                                      defaultValue="0"
                                      min={0}
                                      value={data ? data : 0}
                                      validate={{
                                        required: {
                                          value: true,
                                          errorMessage: t(
                                            'activity.evaluation.number_required'
                                          ),
                                        },
                                        pattern: {
                                          value: '^[0-9]+$',
                                          errorMessage:
                                            'Only numbers are accepted',
                                        },
                                      }}
                                      onBlur={(e) =>
                                        this.onChange(e.target.value, 0, i)
                                      }
                                      disabled={
                                        evalPlan.collectionMethod !== 'MANUAL'
                                      }
                                      style={{
                                        textAlign: 'center',
                                        paddingLeft: '1.5rem',
                                      }}
                                    />
                                  </AvForm>
                                </Table.Cell>
                              ))}
                            </Table.Row>
                          </Table.Body>
                        </Table>
                      </div>
                    </Segment>
                  ) : null}
                  {two && two.length ? (
                    <Segment>
                      <div className="response-table-div">
                        <h4 className="afterBerforeHeading">
                          {t('activity.evaluation.before')}
                        </h4>
                        <Table
                          className="response-table"
                          celled
                          padded
                          unstackable
                        >
                          <Table.Header>
                            <Table.Row>
                              <Table.HeaderCell>
                                {t('common.not_at_all').toUpperCase()}
                              </Table.HeaderCell>
                              <Table.HeaderCell>2</Table.HeaderCell>
                              <Table.HeaderCell>3</Table.HeaderCell>
                              <Table.HeaderCell>4</Table.HeaderCell>
                              <Table.HeaderCell>5</Table.HeaderCell>
                              <Table.HeaderCell>6</Table.HeaderCell>
                              <Table.HeaderCell>7</Table.HeaderCell>
                              <Table.HeaderCell>8</Table.HeaderCell>
                              <Table.HeaderCell>9</Table.HeaderCell>
                              <Table.HeaderCell>
                                {t('common.most_imaginable').toUpperCase()}
                              </Table.HeaderCell>
                            </Table.Row>
                          </Table.Header>
                          <Table.Body>
                            <Table.Row>
                              {map(two, (data, i) => (
                                <Table.Cell key={i}>
                                  <AvForm ref={(c) => (this.data = c)}>
                                    <AvField
                                      type="number"
                                      name={`after-prepost-${i}`}
                                      defaultValue="0"
                                      min={0}
                                      value={data ? data : 0}
                                      validate={{
                                        required: {
                                          value: true,
                                          errorMessage: t(
                                            'activity.evaluation.number_required'
                                          ),
                                        },
                                        pattern: {
                                          value: '^[0-9]+$',
                                          errorMessage:
                                            'Only numbers are accepted',
                                        },
                                      }}
                                      onBlur={(e) =>
                                        this.onChange(e.target.value, 1, i)
                                      }
                                      disabled={
                                        evalPlan.collectionMethod !== 'MANUAL'
                                      }
                                      style={{
                                        textAlign: 'center',
                                        paddingLeft: '1.5rem',
                                      }}
                                    />
                                  </AvForm>
                                </Table.Cell>
                              ))}
                            </Table.Row>
                          </Table.Body>
                        </Table>
                      </div>
                    </Segment>
                  ) : null}
                </>
              ) : one && one.length ? (
                <Segment>
                  <div className="response-table-div">
                    <Table className="response-table" celled padded unstackable>
                      <Table.Header>
                        <Table.Row>
                          <Table.HeaderCell>
                            {t('common.not_at_all').toUpperCase()}
                          </Table.HeaderCell>
                          <Table.HeaderCell>2</Table.HeaderCell>
                          <Table.HeaderCell>3</Table.HeaderCell>
                          <Table.HeaderCell>4</Table.HeaderCell>
                          <Table.HeaderCell>5</Table.HeaderCell>
                          <Table.HeaderCell>6</Table.HeaderCell>
                          <Table.HeaderCell>7</Table.HeaderCell>
                          <Table.HeaderCell>8</Table.HeaderCell>
                          <Table.HeaderCell>9</Table.HeaderCell>
                          <Table.HeaderCell>
                            {t('common.most_imaginable').toUpperCase()}
                          </Table.HeaderCell>
                        </Table.Row>
                      </Table.Header>
                      <Table.Body>
                        <Table.Row>
                          {map(one, (data, i) => (
                            <Table.Cell key={i}>
                              <AvForm ref={(c) => (this.data = c)}>
                                <AvField
                                  type="number"
                                  name={`prepost-${i}`}
                                  defaultValue="0"
                                  value={data ? data : 0}
                                  min={0}
                                  validate={{
                                    required: {
                                      value: true,
                                      errorMessage:
                                        'Number of new workers created is required',
                                    },
                                    pattern: {
                                      value: '^[0-9]+$',
                                      errorMessage: t(
                                        'activity.evaluation.only_numbers_accepted'
                                      ),
                                    },
                                  }}
                                  onBlur={(e) =>
                                    this.onChange(e.target.value, 0, i)
                                  }
                                  disabled={
                                    evalPlan.collectionMethod !== 'MANUAL'
                                  }
                                  style={{
                                    textAlign: 'center',
                                    paddingLeft: '1.5rem',
                                  }}
                                />
                              </AvForm>
                            </Table.Cell>
                          ))}
                        </Table.Row>
                      </Table.Body>
                    </Table>
                  </div>
                </Segment>
              ) : null}

              <div className="graph-div-evaluation">
                <Segment
                  disabled={
                    this.props.currentActivity.statusId == 3 ? true : false
                  }
                >
                  <Grid>
                    <GridColumn
                      className="avg-eval-plan"
                      mobile={16}
                      tablet={16}
                      computer={16}
                    >
                      <div>
                        <label className="title-lbl">
                          {t('activity.evaluation.results')}:{' '}
                          {evaluation && evaluation.outcome
                            ? evaluation.outcome.title
                            : '-'}
                        </label>
                        {evaluation.cumulative === 1 ? (
                          <ul className="align-left-avg-resp">
                            <li>
                              {t('activity.evaluation.pre_average_response', {
                                value: get(
                                  averageValue(evaluation.participantResponse),
                                  'preAverage',
                                  '0.00'
                                ),
                              })}
                            </li>
                            <li>
                              {t('activity.evaluation.post_average_response', {
                                value: get(
                                  averageValue(evaluation.participantResponse),
                                  'postAverage',
                                  '0.00'
                                ),
                              })}
                            </li>
                          </ul>
                        ) : (
                          <ul className="align-left-avg-resp">
                            <li>
                              {t('activity.evaluation.average_response', {
                                value: get(
                                  averageValue(evaluation.participantResponse),
                                  'postAverage',
                                  '0.00'
                                ),
                              })}
                            </li>
                          </ul>
                        )}
                      </div>
                    </GridColumn>
                  </Grid>
                </Segment>
                {participantResponseCount <= 0 ? null : (
                  <div className="eval-qst-charts">
                    {/** <JsonPre data={evaluation}/> **/}
                    <EvaluationReportInclusionToggle
                      evaluation={evaluation}
                      isDisabled={isDisabled}
                      chartMode={chartMode}
                      putEvaluationReportInclusion={
                        putEvaluationReportInclusion
                      }
                    />
                    <ActivityOutcomeRatings
                      activityId={currentActivity?.id}
                      outcomeId={evaluation?.outcomeId}
                      evaluationPlanIds={[evaluation?.evaluationPlanId]}
                      showIncludeToggle={false}
                      showProse={false}
                      onProse={showChartProse ? handleProse : undefined}
                      onChartModeChange={this.handleChartModeChange}
                    />
                  </div>
                )}
              </div>

              {/* ── Analysis narrative ───────────────────────────────────── */}
              <div className="individual-r">
                <div className="border-sep" />
                <div className="survey-results eval-narrative-label">
                  {t('common.analysis')}
                </div>
                <div className="evaluation-comments-margin">
                  <NarrativeCKEditor
                    key={`narrative-${evaluation?.id}`}
                    initialData={this.props.evaluation?.reportNarrative || ''}
                    disabled={isDisabled}
                    onSave={(text) => {
                      const { evaluation } = this.props;
                      this.props.saveEvaluationNarrative(
                        evaluation.projectId,
                        evaluation.id,
                        text
                      );
                      // saveEvaluationNarrative only PUTs — it doesn't update
                      // Redux — so broadcast the save too: ActivitySteps'
                      // central BroadcastChannel listener picks this up and
                      // merges it into Redux directly.
                      const ch = new BroadcastChannel('takso_activity');
                      ch.postMessage({
                        type: 'evaluationNarrative',
                        activityId: evaluation.projectId,
                        evaluationId: evaluation.id,
                        reportNarrative: text,
                      });
                      ch.close();
                    }}
                  />
                </div>
              </div>

              <div className="question-div">
                <label
                  onClick={() => this.controlQuestion()}
                  className="question-lbl"
                >
                  {showQ
                    ? t('activity.evaluation.hide_evaluation_question')
                    : t('activity.evaluation.show_evaluation_question')}
                  {showQ ? (
                    <Icon name="angle up" />
                  ) : (
                    <Icon name="angle down" />
                  )}
                </label>
              </div>
              <div className={showQ ? 'new-show-q' : 'hide-q'}>
                <div dangerouslySetInnerHTML={questioner} />
              </div>

              {/* Only show "Download Response CSV"  button when the responses collected by file (CSV)*/}
              {isCsvImportEnabled &&
              !evalPlan.isNewCsvFeature &&
              participantResponseCount > 0 ? (
                <div className="individual-r mb-2">
                  <div className="participant-download">
                    <div>
                      <Button
                        icon
                        labelPosition="left"
                        className="Secondary-Button"
                        onClick={() =>
                          this.participantResponseExportByFile(evaluation)
                        }
                        loading={this.props.actPut[`evaluationQuestion`]}
                      >
                        <Icon name="download" />
                        <div className="dwn-csv">
                          {t('activity.evaluation.download_response_csv')}
                        </div>
                      </Button>
                    </div>
                    <div className="download-label">
                      {t('activity.evaluation.download_instruction')}
                    </div>
                  </div>
                </div>
              ) : (
                <EvaluationTableComments {...this.props} />
              )}
            </>
          </div>
        </div>
      </Segment>
    );
  }
}

class EvaluationTableComments extends PureComponent {
  constructor(props) {
    super(props);
    // shortlisted: { [responseId]: boolean } — optimistic local state
    this.state = {
      shortlisted: {},
      responseSourceFilter: 'ALL',
    };
    this.handleShortlist = this.handleShortlist.bind(this);
  }

  // Initialise shortlist state from API data when comments load
  componentDidUpdate(prevProps) {
    const { activity, evalPlan } = this.props;
    const prevComments = prevProps.activity.evalComments[evalPlan.id];
    const nextComments = activity.evalComments[evalPlan.id];
    if (nextComments && nextComments !== prevComments) {
      const shortlisted = {};
      (nextComments.form || []).forEach((row) => {
        (row.result || []).forEach((item) => {
          if (item.id != null) {
            shortlisted[item.id] = Boolean(item.isShortlisted);
          }
        });
      });
      this.setState({ shortlisted });
    }
  }

  handleShortlist(responseId, currentValue) {
    const { activity, toggleCommentShortlist } = this.props;
    const projectId = activity.currentActivity?.id;
    const next = !currentValue;
    // Optimistic update
    this.setState((prev) => ({
      shortlisted: { ...prev.shortlisted, [responseId]: next },
    }));
    toggleCommentShortlist(projectId, responseId, next);
  }

  getSourceLabel(collectionMethod) {
    const { t } = this.props;

    switch (collectionMethod) {
      case 'CSV':
        return t('survey.csv_upload');
      case 'CULTURECOUNTS':
        return t('survey.culture_counts');
      case 'ONLINE':
      default:
        return t('survey.online_survey');
    }
  }

  getEvalComments() {
    const { activity, evalPlan } = this.props;
    for (const [key, value] of Object.entries(activity.evalComments)) {
      if (key == evalPlan.id) {
        return value;
      }
    }
    return {};
  }

  getOrderedObjectives(evalComments = null) {
    // make sure objectives are ordered by outcome id
    return orderBy(
      (evalComments || this.getEvalComments()).objectives,
      ['outcomeId'],
      ['asc']
    );
  }

  headerColumns(evalComments) {
    const { t } = this.props;
    const objectives = this.getOrderedObjectives(evalComments);
    const [first, second] = objectives;
    const additionalQuestions = filter(evalComments.additionalQuestions);

    let isAdditionalAvailable = isEmpty(additionalQuestions);

    const headers = [
      {
        title: '',
        colSpan: '1',
      },
      {
        title: get(first, 'outcomeTitle', null),
        colSpan: get(first, 'cumulative', null) ? '3' : '2',
        textAlign: 'left',
      },
      size(objectives) === 2
        ? {
            title: get(second, 'outcomeTitle', null),
            colSpan: get(second, 'cumulative', null) ? '3' : '2',
            textAlign: 'left',
          }
        : null,
      !isAdditionalAvailable
        ? {
            title: t('activity.evaluation.additional_questions'),
            colSpan: size(additionalQuestions),
            textAlign: 'left',
          }
        : null,
    ];

    return compact(headers);
  }

  getColumns(evalComments) {
    const { t } = this.props;
    const objectives = this.getOrderedObjectives(evalComments);
    const [first, second] = objectives;

    let columns = [
      {
        width: '2',
        title: (
          <div className="preRat-small">{t('activity.evaluation.source')}</div>
        ),
        render: (data) => this.getSourceLabel(data.collectionMethod),
      },
      {
        width: '2',
        title: (
          <div className="preRat-small">
            {t('activity.evaluation.post_rate')}
          </div>
        ),
        render: (data) => {
          return map(data.result, (item) =>
            first.objectiveId === item.objectiveId ? item.postResult : null
          );
        },
      },
      get(first, 'cumulative', null)
        ? {
            width: '2',
            title: (
              <div className="preRat-small">
                {t('activity.evaluation.pre_rate')}
              </div>
            ),
            render: (data) => {
              return map(data.result, (item) =>
                first.objectiveId === item.objectiveId ? item.preResult : null
              );
            },
          }
        : null,
      {
        width: '4',
        title: (
          <div className="comment-section">
            {t('activity.evaluation.comments')}
          </div>
        ),
        render: (data) => {
          return map(data.result, (item) => {
            if (first.objectiveId !== item.objectiveId) return null;
            const isShortlisted = this.state.shortlisted[item.id] || false;
            return (
              <div key={item.id} className="comment-shortlist-wrap">
                <CopyToClipboard
                  text={item.reason}
                  onCopy={() =>
                    NotificationManager.info(
                      t('common.copied_to_clipboard'),
                      t('common.comment')
                    )
                  }
                >
                  <div className="copy-comment">{item.reason}</div>
                </CopyToClipboard>
                {item.reason && (
                  <button
                    className={`shortlist-tick${
                      isShortlisted ? ' shortlist-tick--active' : ''
                    }`}
                    title={
                      isShortlisted
                        ? t('activity.evaluation.remove_from_report_shortlist')
                        : t('activity.evaluation.add_to_report_shortlist')
                    }
                    onClick={(e) => {
                      e.stopPropagation();
                      this.handleShortlist(item.id, isShortlisted);
                    }}
                  >
                    ✓
                  </button>
                )}
              </div>
            );
          });
        },
      },
    ];

    const secondObjColumns = [
      {
        width: '2',
        title: (
          <div className="preRat-small">
            {t('activity.evaluation.post_rate')}
          </div>
        ),
        render: (data) => {
          return map(data.result, (item) =>
            second.objectiveId === item.objectiveId ? item.postResult : null
          );
        },
      },
      get(second, 'cumulative', null)
        ? {
            width: '2',
            title: (
              <div className="preRat-small">
                {t('activity.evaluation.pre_rate')}
              </div>
            ),
            render: (data) => {
              return map(data.result, (item) =>
                second.objectiveId === item.objectiveId ? item.preResult : null
              );
            },
          }
        : null,
      {
        width: '4',
        title: (
          <div className="comment-section">
            {t('activity.evaluation.comments')}
          </div>
        ),
        render: (data) => {
          return map(data.result, (item) => {
            if (second.objectiveId !== item.objectiveId) return null;
            const isShortlisted = this.state.shortlisted[item.id] || false;
            return (
              <div key={item.id} className="comment-shortlist-wrap">
                <CopyToClipboard
                  text={item.reason}
                  onCopy={() =>
                    NotificationManager.info(
                      t('common.copied_to_clipboard'),
                      t('common.comment')
                    )
                  }
                >
                  <div className="copy-comment">{item.reason}</div>
                </CopyToClipboard>
                {item.reason && (
                  <button
                    className={`shortlist-tick${
                      isShortlisted ? ' shortlist-tick--active' : ''
                    }`}
                    title={
                      isShortlisted
                        ? t('activity.evaluation.remove_from_report_shortlist')
                        : t('activity.evaluation.add_to_report_shortlist')
                    }
                    onClick={(e) => {
                      e.stopPropagation();
                      this.handleShortlist(item.id, isShortlisted);
                    }}
                  >
                    ✓
                  </button>
                )}
              </div>
            );
          });
        },
      },
    ];

    if (size(objectives) === 2) {
      columns = columns.concat(...secondObjColumns);
    }

    let extraColumns = [];

    if (!isEmpty(evalComments.additionalQuestions)) {
      extraColumns.push(
        map(evalComments.additionalQuestions, (ques) => {
          let questionLength = ques.type.length;
          let question = ques.type;
          let lengthyQuestion = '';
          if (questionLength > 20) {
            lengthyQuestion = question.substring(0, 20) + '...';
          }
          let agePostcode = false;

          if (
            question === 'Age' ||
            question === 'Postcode' ||
            question === 'Email'
          ) {
            agePostcode = true;
          }
          return {
            width: agePostcode ? '2' : '4',
            title:
              questionLength > 20 ? (
                <Popup
                  content={question}
                  trigger={
                    <div
                      className={
                        agePostcode ? 'preRat-small' : 'comment-section'
                      }
                    >
                      {lengthyQuestion}
                    </div>
                  }
                />
              ) : (
                <div
                  className={agePostcode ? 'preRat-small' : 'comment-section'}
                >
                  {question}
                </div>
              ),
            render: (data) => {
              return map(data.additionalQuestionAnswer, (item) => {
                if (ques.id !== item.id) return null;
                return <div className="pre-line">{item.answer}</div>;
              });
            },
          };
        })
      );
    }

    let allColumns = columns.concat(...extraColumns);

    return compact(allColumns);
  }

  async participantResponseExport(evaluation) {
    const { exportEvaluationResponses } = this.props;
    const { responseSourceFilter } = this.state;
    await exportEvaluationResponses(
      `evaluationQuestion`,
      evaluation,
      responseSourceFilter === 'ALL' ? null : responseSourceFilter
    );
    const { evaluationResponsesCsvLink } = this.props;
    if (!isEmpty(evaluationResponsesCsvLink)) {
      window.open(evaluationResponsesCsvLink.download_link, '_blank');
    }
  }

  render() {
    const { t, evalPlan, evaluation } = this.props;
    const evaluationComments = this.getEvalComments();
    const { responseSourceFilter } = this.state;
    const availableSources = compact(
      map(['ONLINE', 'CSV', 'CULTURECOUNTS'], (source) =>
        evaluationComments.form &&
        evaluationComments.form.some(
          (response) => response.collectionMethod === source
        )
          ? source
          : null
      )
    );
    const showResponseSourceFilter = availableSources.length > 1;
    const filteredForm =
      responseSourceFilter === 'ALL'
        ? evaluationComments.form
        : filter(evaluationComments.form, {
            collectionMethod: responseSourceFilter,
          });

    return (
      <div className="individual-r">
        {isEmpty(evaluationComments.form) ? null : (
          <>
            <div className="border-sep"></div>
            <label className="participant-lbl individual-responses-heading">
              {t('activity.evaluation.individual_responses')}
            </label>

            <div className="evaluation-comments-margin">
              {showResponseSourceFilter ? (
                <div className="response-source-filter">
                  <Button.Group size="small">
                    <Button
                      type="button"
                      active={responseSourceFilter === 'ALL'}
                      onClick={() =>
                        this.setState({ responseSourceFilter: 'ALL' })
                      }
                    >
                      {t('common.all')}
                    </Button>
                    {map(availableSources, (source) => (
                      <Button
                        key={source}
                        type="button"
                        active={responseSourceFilter === source}
                        onClick={() =>
                          this.setState({ responseSourceFilter: source })
                        }
                      >
                        {this.getSourceLabel(source)}
                      </Button>
                    ))}
                  </Button.Group>
                </div>
              ) : null}

              {evalPlan.collectionMethod !== 'CULTURECOUNTS' && (
                <div className="comments-table">
                  <CustomTable
                    // structured={true}
                    parentHeaders={this.headerColumns(evaluationComments)}
                    header
                    columns={this.getColumns(evaluationComments)}
                    data={filteredForm}
                    customClass="doc-evaluation-comments"
                    keyExtractor={(item, index) => item.id}
                  />
                </div>
              )}

              {evalPlan.collectionMethod !== 'MANUAL' ? (
                <div className="participant-download">
                  <div>
                    <Button
                      icon
                      labelPosition="left"
                      className="Secondary-Button"
                      onClick={() => this.participantResponseExport(evaluation)}
                      loading={this.props.actPut[`evaluationQuestion`]}
                    >
                      <Icon name="download" />
                      <div className="dwn-csv">
                        {t('activity.evaluation.download_response_csv')}
                      </div>
                    </Button>
                  </div>
                  <div className="download-label">
                    {t('activity.evaluation.download_instruction')}
                  </div>
                </div>
              ) : null}
            </div>
          </>
        )}
      </div>
    );
  }
}

EvaluationTableComments = withTranslation()(EvaluationTableComments);

const mapStateToProps = (state) => {
  return {
    activity: state.activity,
    extra: state.extra,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      postProjectEvaluations,
      uploadActivityCsv,
      getEvalReasons,
      getEvalAssesmentTypes,
      updateSelfAssessed,
      evalPlanManage,
      exportEvaluationResponses,
      exportEvaluationResponsesByFile,
      getEvaluationComment,
      getEvaluationPlans,
      saveEvaluationNarrative,
      toggleCommentShortlist,
      putEvaluationReportInclusion,
    },
    dispatch
  );
};

EvaluationQuestion = connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(EvaluationQuestion));

EvaluationQuestion = withTranslation()(EvaluationQuestion);

export { EvaluationQuestion };
